import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@material-ui/core'
import { flattenNoFollow } from '../../../../../utils/flatten'
import NullValue from '../../../../molecules/NullValue'
import QueryResultTable from './QueryResultTable'

const missing = <>&lt;missing&gt;</>

function QueryTableCell ({ value }) {
  if (value === undefined) {
    return <NullValue value={missing} />
  }
  if (value === null) {
    return <NullValue />
  }
  if (typeof value === 'object') {
    return (
      <Tooltip title={<pre>{JSON.stringify(value, null, 2)}</pre>}>
        <span>...</span>
      </Tooltip>
    )
  }

  return <div>{value}</div>
}

QueryTableCell.propTypes = {
  value: PropTypes.any
}

function AutoTable ({ data }) {
  const columns = useMemo(() => {
    // handle if data is not an array
    const allColumns = (!Array.isArray(data) ? [] : data || []).reduce((p, c) => {
      const cFlat = flattenNoFollow(c)
      const fields = Object.entries(cFlat)
      fields.forEach(([key, value]) => {
        if (key in p) return
        p[key] = typeof value
      })

      return p
    }, {})

    const dataColumns = Object.entries(allColumns).map(([key]) => {
      return {
        id: key,
        header: key,
        accessorKey: key,
        format: 'title',
        cell: ({ getValue }) => <QueryTableCell value={getValue()} />
      }
    })

    // Prepend row number column
    return [
      {
        id: '_rowNum',
        header: '#',
        size: 60,
        enableSorting: false,
        cell: ({ row, table }) => {
          const { pageIndex, pageSize } = table.getState().pagination
          return (
            <div style={{ textAlign: 'right', color: '#666', fontFamily: 'monospace' }}>
              {pageIndex * pageSize + row.index + 1}
            </div>
          )
        }
      },
      ...dataColumns
    ]
  }, [data])
  const defaultSort = [{ id: 'levelId', desc: false }]

  if (!data?.length) {
    return null
  }

  return (
    <QueryResultTable
      columns={columns}
      defaultSort={defaultSort}
      data={data}
    />
  )
}

AutoTable.propTypes = {
  data: PropTypes.array
}

export default AutoTable
